export const filterFixtures = (fixtures, selectedLeaguesIds) => {
  return fixtures.filter((x) => selectedLeaguesIds.includes(x.league_id));
};
